module.exports = __webpack_public_path__ + "img/couples_13_V.a55be747.webp";